import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter, HashRouter } from "react-router-dom";
import App from "@/app/App";
import { AppProviders } from "@/app/AppProviders";
import { env } from "@/config/env";
import "@/styles/theme.css";
import "@/styles/index.css";

// Register Service Worker for offline caching and instant reloads
if ('serviceWorker' in navigator && env.environment === 'production') {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/sw.js')
      .then((registration) => {
        console.log('[SW] Registered:', registration.scope);
      })
      .catch((error) => {
        console.error('[SW] Registration failed:', error);
      });
  });
}

const rootElement = document.getElementById("root");

if (!rootElement) {
  throw new Error("Application root element #root was not found.");
}

const Router = env.routerMode === "hash" ? HashRouter : BrowserRouter;

createRoot(rootElement).render(
  <StrictMode>
    <AppProviders>
      <Router>
        <App />
      </Router>
    </AppProviders>
  </StrictMode>,
);
